/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Plan_StudentInputs */

const en_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const de_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const fr_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étudiant`)
};

const es_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudiante`)
};

const it_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studente`)
};

const nl_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const pl_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const fi_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opiskelija`)
};

const da_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studerende`)
};

const sv_settings_plan_student = /** @type {(inputs: Settings_Plan_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

/**
* | output |
* | --- |
* | "Student" |
*
* @param {Settings_Plan_StudentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_plan_student = /** @type {((inputs?: Settings_Plan_StudentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Plan_StudentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_plan_student(inputs)
	if (locale === "fr") return fr_settings_plan_student(inputs)
	if (locale === "es") return es_settings_plan_student(inputs)
	if (locale === "it") return it_settings_plan_student(inputs)
	if (locale === "nl") return nl_settings_plan_student(inputs)
	if (locale === "pl") return pl_settings_plan_student(inputs)
	if (locale === "fi") return fi_settings_plan_student(inputs)
	if (locale === "da") return da_settings_plan_student(inputs)
	if (locale === "sv") return sv_settings_plan_student(inputs)
	return en_settings_plan_student(inputs)
});